"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fragments_1 = require("../fragments");
const notifi_axios_utils_1 = require("@notifi-network/notifi-axios-utils");
const DEPENDENCIES = [
    ...fragments_1.clientConfigurationFragmentDependencies,
    fragments_1.clientConfigurationFragment,
];
const QUERY = `
query getConfigurationForDapp($dappAddress: String!) {
  configurationForDapp(getConfigurationForDappInput: {
    dappAddress: $dappAddress
  }) {
    ...clientConfigurationFragment
  }
}
`.trim();
const getConfigurationForDappImpl = (0, notifi_axios_utils_1.makeRequest)((0, notifi_axios_utils_1.collectDependencies)(...DEPENDENCIES, QUERY), 'configurationForDapp');
exports.default = getConfigurationForDappImpl;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0Q29uZmlndXJhdGlvbkZvckRhcHBJbXBsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vbGliL3F1ZXJpZXMvZ2V0Q29uZmlndXJhdGlvbkZvckRhcHBJbXBsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsNENBR3NCO0FBQ3RCLDJFQUc0QztBQU01QyxNQUFNLFlBQVksR0FBRztJQUNuQixHQUFHLG1EQUF1QztJQUMxQyx1Q0FBMkI7Q0FDNUIsQ0FBQztBQUVGLE1BQU0sS0FBSyxHQUFHOzs7Ozs7OztDQVFiLENBQUMsSUFBSSxFQUFFLENBQUM7QUFFVCxNQUFNLDJCQUEyQixHQUFHLElBQUEsZ0NBQVcsRUFHN0MsSUFBQSx3Q0FBbUIsRUFBQyxHQUFHLFlBQVksRUFBRSxLQUFLLENBQUMsRUFBRSxzQkFBc0IsQ0FBQyxDQUFDO0FBRXZFLGtCQUFlLDJCQUEyQixDQUFDIn0=